import { Component } from '@angular/core';
import { DriverDash } from "../dash/driver-dash/driver-dash";
import { CallcentreDash } from "../dash/callcentre-dash/callcentre-dash";
import { AuthService } from '../auth.service';
import { NotificationService } from '../shared/notification.service';
import { BdtechDash } from '../dash/bdtech-dash/bdtech-dash';

@Component({
  selector: 'app-home',
  imports: [DriverDash, CallcentreDash, BdtechDash],
  templateUrl: './home.html',
  styleUrl: './home.less'
})
export class Home {


  constructor(public authService: AuthService, private notification: NotificationService) { }



}
